import { formatMessage } from '@99designs/common/i18n';
import classNames from 'classnames';
import Header from 'projects/components/Header';
import HeaderUserLayout from 'projects/components/HeaderUserLayout';
import Link from 'projects/components/Link';
import { Color } from 'projects/consts';
import { StepState } from 'projects/util/step';
import React from 'react';
import ColorComponent from './Color';
import { Designer as DesignerInterface } from './User';

interface Props {
    step: StepState;
    designers: Array<DesignerInterface>;
}

export default class StepHeader extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    title() {
        return this.props.step.currentStep().title;
    }

    render() {
        const { step, designers } = this.props;

        const headerClasses = classNames('heading', 'heading--h2', {
            'heading--no-margin': step.isDesignerStep(),
        });

        return (
            <Header variation="fixed-width" title={`${this.title()} | 99designs`}>
                <div className="header__back">
                    {step.hasStepBefore() && (
                        <Link to={step.prevUrl()} variations={['back', 'big-target']}>
                            {__('Back')}
                        </Link>
                    )}
                </div>

                <div className="header__steps">
                    {formatMessage(__('Step {step} of {totalSteps}'), {
                        step: step.number,
                        totalSteps: step.stepCount(),
                    })}
                </div>

                <ColorComponent color={Color.createBlue}>
                    <h2 className={headerClasses}>{this.title()}</h2>
                </ColorComponent>
                {!step.isDesignerStep() && designers.length > 0 && (
                    <HeaderUserLayout users={designers} />
                )}
            </Header>
        );
    }
}
